import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=a6753604&scoped=true&lang=pug&"
import script from "./Conversation.vue?vue&type=script&lang=ts&"
export * from "./Conversation.vue?vue&type=script&lang=ts&"
import style0 from "./Conversation.vue?vue&type=style&index=0&id=a6753604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6753604",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSpacer,VTextField})
